<template>
  <div class="card-login">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-sm-8 mb-5">
          <img 
            v-if="emp.login.bazar_login !== null"
            :src="UrlImgDrive+emp.login.bazar_login" 
            class="d-block mx-auto" 
            alt="Login" 
            style="max-width: 100%;"
          >
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12 col-sm-12 col-md-4 col-lg-4">
          <div class="card shadow-sm p-3 bg-white rounded">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h2 class="mb-5 font-weight-normal ml-1 text-left text-login">Iniciar sesión</h2>
                </div>
              </div>
              <form @submit.prevent="login">
                <div class="alert alert-danger" v-if="mensaje !== null">{{ mensaje }}</div>
                <div class="row form-group mb-2">
                  <div class="col-sm-12">
                    <label class="mb-1">Usuario:</label>
                    <input type="text" class="form-control" placeholder="Nombre de usuario" v-model="form.usuario" :required="true">
                  </div>
                </div>
                <div class="row form-group mb-3">
                  <div class="col-sm-12">
                    <label class="mb-1">Clave:</label>
                    <input type="password" class="form-control" placeholder="Clave de acceso" v-model="form.clave" :required="true">
                  </div>
                </div>

                <div class="row form-group mb-2">
                  <div class="col-sm-12">
                    <button class="btn btn-block btn-primary" :disabled="btnLogin">
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="btnLogin"></span> {{ btnLogin === true ? ' Iniciando...':'Iniciar' }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'BazarLogin',
    props: {
      emp: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      btnLogin: false,
      mensaje: null,
      form: {}
    }),
    methods: {
      login() {
        this.btnLogin = true;
        this.mensaje  = null;
        this.form.dominio = this.emp.dominio;
        
        axios
        .post(this.UrlBase+'/bazar/valida_usuario', this.form)
        .then(res => {
          if (res.data.exito) {

            let tmp = {
              token: res.data.token,
              usuario: res.data.usuario
            };

            localStorage.setItem(`bazar_${this.emp.dominio}`, JSON.stringify(tmp))

            this.$emit('actualiza', {
              login: false,
              usuario: res.data.usuario
            });
          } else {
            this.mensaje = res.data.mensaje;
          }

          this.btnLogin = false;
        }).catch(e => {
          this.mensaje = 'Login ' + e;
          this.btnLogin = false;
        });
      }
    }
  }
</script>
<style>
.card-login {
  position: absolute;
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center; 
}

.text-login:before { 
  content: "";
  position: absolute;
  height: 3px; 
  width: 183px;
  background: #1f2667;
  bottom: 40px;
}
</style>